import { Box, type SxProps, type Theme } from '@mui/material';

import { slateInkTokens } from '@src/theme/slateInkTheme';

/** Trove orange — the brand accent — used by every "Trove only" indicator. */
export const TROVE_ONLY_COLOR = slateInkTokens.accent;

/**
 * Small Trove-orange pill reading "Trove only". Marks UI that external partner users can't see;
 * use it on tabs and anywhere else a lighter marker than the full <TroveOnly> frame fits.
 */
export const TroveOnlyBadge = ({ sx }: { sx?: SxProps<Theme> }) => (
  <Box
    component="span"
    sx={[
      {
        display: 'inline-flex',
        alignItems: 'center',
        px: 0.75,
        height: 18,
        borderRadius: 9,
        bgcolor: TROVE_ONLY_COLOR,
        color: slateInkTokens.accentContrast,
        fontSize: 10.5,
        fontWeight: 600,
        lineHeight: 1,
        letterSpacing: '.02em',
        whiteSpace: 'nowrap',
        textTransform: 'none',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    Trove only
  </Box>
);

export default TroveOnlyBadge;
